import { ValueOf } from './util';

/** 付与口座のenum */
export const bulkGrantAccountTypes = {
  BONUS_VALUE: 'ボーナスバリュー',
  BONUS_POINT: 'ボーナスポイント',
} as const;

export type BulkGrantAccountTypeKey = keyof typeof bulkGrantAccountTypes;
export type BulkGrantAccountTypeValue = ValueOf<typeof bulkGrantAccountTypes>;

export const bulkGrantAccountTypeKeys = Object.keys(bulkGrantAccountTypes) as (BulkGrantAccountTypeKey[]);

/** v-select用items */
export const bulkGrantAccountTypeItems = bulkGrantAccountTypeKeys
  .map((key) => ({
    title: bulkGrantAccountTypes[key],
    value: key,
  }));
